exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-directmessaging-window{height:400px}#asseco-directmessaging-window .asseco-list-item-label{width:calc(100% - 40px);display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#asseco-directmessaging-window .newMessage .asseco-list-item-label{font-weight:600}#asseco-directmessaging-window .itemDesc{display:inline-flex;width:100%;height:22px}#asseco-directmessaging-window .itemDescPrim{flex-grow:1;padding-left:40px}#asseco-directmessaging-window .itemDescSec{align-self:flex-end;margin-bottom:0}", ""]);

// exports
